import React, { useRef, useEffect, Profiler } from "react";

import AppShell from "../components/elements/AppShell";
import { Container, Text } from "@bookingcom/bui-react";
import NotAvailableIllustration from "../assets/illustrations/not-available.svg";
import { t } from "@bookingcom/lingojs-core";
import { useI18n, I18nChildContext } from "@bookingcom/lingojs-react";
import { Helmet } from "react-helmet-async";

import { useGoogleFlightsPriceAccuracyTag } from "../hooks/useGTMPriceAccuracyTags";
import useGlobalContext from "../hooks/useGlobalContext";
import useClientMetrics from "../hooks/useClientMetrics";

import styles from "./NotAvailable.module.css";
import { GOOGLE_FLIGHTS_EXT_ORIGIN_PARAM_VALUES } from "@flights/constants";

const NotAvailable: React.FunctionComponent = function () {
  const i18n = useI18n() as I18nChildContext;

  const qs = new URLSearchParams(window.location.search);
  const redirectOrigin = qs.get("redirect-origin");

  const isOfGoogleFlightsOrigin = redirectOrigin && GOOGLE_FLIGHTS_EXT_ORIGIN_PARAM_VALUES.includes(redirectOrigin);
  const googleFlightsPriceAccuracyTag = useGoogleFlightsPriceAccuracyTag();
  const { trackRenderTime } = useClientMetrics();

  const trackingRef = useRef({
    googleFlightsPriceAccuracyTag
  });

  useEffect(() => {
    const { googleFlightsPriceAccuracyTag } = trackingRef.current;
    if (isOfGoogleFlightsOrigin) {
      //send price as -1 to separate tag values from normal landing (in flight details)
      //where we send price as 0
      googleFlightsPriceAccuracyTag(-1, "");
    }
  }, [isOfGoogleFlightsOrigin]);

  return (
    <Profiler id="screen" onRender={trackRenderTime}>
      <PageHeader />
      <AppShell>
        <Container fullWidth={false} className={styles.root} mixin={{ paddingBlockStart: 4, paddingBlockEnd: 4 }}>
          <NotAvailableIllustration />
          <Container className={styles.text} fullWidth mixin={{ paddingBlockStart: 4, paddingBlockEnd: 4 }}>
            <Text variant="featured_2">{i18n.trans(t("flights_g_redirect_header"))}</Text>
            <Text variant="body_1">{i18n.trans(t("flights_g_redirect_subheader"))} </Text>
          </Container>
        </Container>
      </AppShell>
    </Profiler>
  );
};

const PageHeader: React.FunctionComponent<{ isWebview?: boolean; children?: React.ReactNode }> = (props) => {
  const { locale } = useGlobalContext();
  let redirectUrl = "http://www.booking.com/";
  if (locale) {
    redirectUrl = `http://www.booking.com/?lang=${locale}`;
  }
  return (
    <Helmet>
      <meta name="robots" content="noindex" />
      <meta httpEquiv="refresh" content={`3; url=${redirectUrl}`} />

      {props.children}
    </Helmet>
  );
};
export default NotAvailable;
